import Slider from "components/store/AdSlider";
import AmazingProduct from "components/store/AmazingProduct";
import SpecialProduct from "components/store/SpecialProducts";
import Products from "components/store/StoreProducts";
import { productDataToQuery } from "utils/helperFunctions";
import special1 from "assets/images/Component 1.png";
import special2 from "assets/images/Component 2.png";
import special3 from "assets/images/Component 3.png";
import special5 from "assets/images/Component 6.png";
import { translateToReactSelect } from "utils/helperFunctions";
import special4 from "assets/images/Component 4.png";

import Search from "components/main/Search";

import { useState, useEffect } from "react";
import sendRequest from "hooks/useAxios";
import first from "assets/images/Component5.png";
import second from "assets/images/2.jpg";

import { Helmet } from "react-helmet";

import AddProductModal from "components/store/addProductModal/AddProductModal";
import EdiSpecialProductModal from "../components/store/EditSpecialProductModal";
import ReactDOM from "react-dom";
import { useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import Loader from "utils/Loader.jsx";

export default function Store() {
  const auth = useContext(WithAuthentication);
  const [colors, setColors] = useState([]);
  const [tags, setTags] = useState([]);
  const [tagOption, setTagOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [product, setProduct] = useState([
    {
      title: "لپ تاپ 11 اینچی لنوو",
      name: "هارد اکسترنال ای دیتا مدل hd710pro",
      brand: "ای دیتا",
      score: "4.1",
      rate: 4,
      count: 88,
      price: 20000000,
      discount: 10000000,
      source: first,
      startDate: 1647107531,
      endDate: 1648891659
    },
    {
      title: "لپ تاپ 13 اینچی لنوو",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      rate: 3,
      count: 80,
      price: 30000000,
      discount: 12000000,
      source: first,
      startDate: 1647107531,
      endDate: 1649811659
    },
    {
      title: "لپ تاپ 11 اینچی لنوو لپ تاپ 11 اینچی لنوو",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      rate: 4,
      count: 88,
      price: 20000000,
      discount: 20000000,
      source: second,
      startDate: 1647107531,
      endDate: 1649871659
    },
    {
      title:
        " لپ تاپ 13 اینچی لنوو لپ تاپ 13 اینچی لنوو لپ تاپ 13 اینچی لنوولپ تاپ 13 اینچی لنوو",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      rate: 3,
      count: 80,
      price: 30000000,
      discount: 27644444,
      source: second,
      startDate: 1647107531,
      endDate: 1648891659
    },
    {
      title: "لپ تاپ 11 اینچی لنوو",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      rate: 4,
      count: 88,
      price: 20000000,
      discount: "",
      source: second,
      startDate: 1647107531,
      endDate: 1647451754
    },
    {
      title: "لپ تاپ 13 اینچی لنوو",
      name: "لپ تاپ 17/3 اینچی اپل",
      brand: "اپل",
      score: "4.1",
      rate: 3,
      count: 80,
      price: 30000000,
      discount: 20000000,
      source: first,
      startDate: 1647107478,
      endDate: ""
    }
  ]);
  const [specialProduct, setSpecialProduct] = useState(
    // { source0: "", source1: "", source2: "", source3: "" }
    [
      { source: special1, url: "" },
      { source: special2, url: "" },
      { source: special3, url: "" },
      { source: special5, url: "" }
    ]
  );
  const [configUpdater, setConfigUpdater] = useState(false);
  const configHandler = () => {
    setConfigUpdater(prev => !prev);
  };

  const [tabs, setTabs] = useState([
    {
      title: "محصولات",
      status: 1,
      items: [
        {
          title: "لپ تاپ 11 اینچی لنوو",
          name: "هارد اکسترنال ای دیتا مدل hd710pro",
          brand: "ای دیتا",
          score: "4.1",
          rate: 4.1,
          count: 88,
          price: 20000000,
          discount: 10000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647267674
        }
      ]
    },
    {
      title: "جدیدترین",
      status: 0,
      items: [
        {
          title:
            " لپ تاپ 13 اینچی لنوو لپ تاپ 13 اینچی لنوو لپ تاپ 13 اینچی لنوولپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 15/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 27644444,
          source: second,
          startDate: 1647107531,
          endDate: 1647451274
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        }
      ]
    },
    {
      title: "محبوبترین",
      status: 1,
      items: [
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        },
        {
          title: "لپ تاپ 13 اینچی لنوو",
          name: "لپ تاپ 17/3 اینچی اپل",
          brand: "اپل",
          score: "4.1",
          rate: 3.8,
          count: 80,
          price: 30000000,
          discount: 12000000,
          source: first,
          startDate: 1647107531,
          endDate: 1647278474
        }
      ]
    }
  ]);
  const isAdmin = auth.userInfo.userType == 0;
  const [getQuery, setGetQuery] = useState([
    { querys: "", source: "" },
    { querys: "", source: "" },
    { querys: "", source: "" },
    { querys: "", source: "" }
  ]);
  const urlHandler = (i, names, value) => {
    setSpecialProduct(prev => {
      let w = [...prev];
      return { ...w[i], [names]: value };
    });
  };
  const translateProductToReactSelect = (arrayValue, reverse) => {
    let after = [];
    if (reverse) {
      // react select to api
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.title = arrayValue[index].label;
        obj.id = arrayValue[index].value;

        after.push(obj);
      }
    } else {
      // api to react select
      for (let index = 0; index < arrayValue.length; index++) {
        let obj = {};
        obj.label = arrayValue[index].title;

        obj.value = arrayValue[index].id;

        after.push(obj);
      }
    }

    return after;
  };
  const [productOption, setProductOption] = useState([]);
  const [amazingProduct, setAmazingProduct] = useState([]);
  const [productList, setProductList] = useState([]);
  const [brands, setBrands] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    async function pageLoad() {
      await sendRequest("Find_products", {
        tbl_name: `left join,files,coverimg_fileid,id`,
        conditions: `main_discount/!=/0@@main_discount_endtime/>/'${Math.floor(
          new Date() / 1000
        )}'`
      }).then(({ data }) => {
        setAmazingProduct(data);
      });
      await sendRequest("getlistofproduct").then(({ data }) => {
        setProductList(data.productList);
      });
      // setIsLoading(false);
      await sendRequest("Find_boxs_configs", { conditions: "id/=/18" }).then(
        data => {
          // setGetQuery(data.data[0].custom_config.split("##"));
          // setSpecialProduct((prev) => {
          //   let w = [...prev];
          //   w[0].source = getQuery.split("##")[0].split("@@")[0];

          for (let i = 0; i < 4; i++) {
            setGetQuery(prev => {
              let datas = data.data[0].custom_config.split("##");
              let temp = [...getQuery];
              temp[i].source = datas[i].split("@@")[0];
              temp[i].querys = datas[i].split("@@")[1];

              return temp;
            });
          }

          specialProduct[0].source = data.data[0].custom_config
            .split("##")[0]
            .split("@@")[0];

          specialProduct[0].url = productDataToQuery(
            data.data[0].custom_config.split("##")[0].split("@@")[1],
            true
          );

          specialProduct[1].source = data.data[0].custom_config
            .split("##")[1]
            .split("@@")[0];

          specialProduct[1].url = productDataToQuery(
            data.data[0].custom_config.split("##")[1].split("@@")[1],
            true
          );

          specialProduct[2].source = data.data[0].custom_config
            .split("##")[2]
            .split("@@")[0];
          specialProduct[2].url = productDataToQuery(
            data.data[0].custom_config.split("##")[2].split("@@")[1],
            true
          );

          specialProduct[3].source = data.data[0].custom_config
            .split("##")[3]
            .split("@@")[0];
          specialProduct[3].url = productDataToQuery(
            data.data[0].custom_config.split("##")[3].split("@@")[1],
            true
          );
        }
      );

      await sendRequest("Find_products", {
        tbl_name: `left join,files,coverimg_fileid,id`,
        conditions: "files.type/=/1"
      }).then(({ data }) => {
        setProductOption(translateProductToReactSelect(data, false));
      });
      await sendRequest("Find_color").then(({ data }) => {
        setColors(data);
      });
      await sendRequest("Find_hashtags").then(({ data }) => {
        setTagOption(translateToReactSelect(data, false));
      });
      await sendRequest("Find_brand").then(({ data }) => {
        setBrands(prev => {
          return [{ name: "ثبت برند جدید", id: "create" }, ...data];
        });
      });
    }
    pageLoad();
  }, [configUpdater]);

  // for (let i = 0; i < specialProduct.length; i++) {
  //   setSpecialProduct((prev) => {
  //     let w = [...prev];
  //     console.log(getQuery);
  //     // w[i].source = getQuery[i].split("@@");
  //     return w;
  //   });
  //   // console.log(getQuery[i]);
  // }

  return (
    <div className="store">
      {isLoading && <Loader />}
      <div>
        <Helmet>
          <title>فروشگاه </title>
        </Helmet>
      </div>

      <div
        className="position-relative search-input mx-auto display-input d-none mt-3"
        style={{ width: "70%" }}
      >
        <Search />
      </div>

      <Slider
        isAdmin={isAdmin}
        productList={productList}
        setIsLoading={setIsLoading}
      ></Slider>
      <AmazingProduct
        products={product}
        cover={special4}
        isAdmin={isAdmin}
        amazingProduct={amazingProduct}
      ></AmazingProduct>
      <EdiSpecialProductModal
        products={specialProduct}
        configHandler={configHandler}
        // setSpecialProduct={setSpecialProduct}
        // brandOption={brandOption}
        // tagOption={tagOption}
        tagOption={tagOption}
        setTagOption={setTagOption}
        productOption={productOption}
      />
      <SpecialProduct
        query={getQuery}
        products={specialProduct}
        isAdmin={isAdmin}
      ></SpecialProduct>
      {isAdmin && (
        <div className="d-flex justify-content-start">
          <button
            className="btn mx-3 "
            style={{
              backgroundColor: "navy",
              color: "white",
              borderRadius: "5px"
            }}
            data-bs-toggle="modal"
            data-bs-target="#addProductModal"
          >
            افزودن محصول
          </button>
        </div>
      )}

      <Products tabs={tabs} page="store" products={product}></Products>

      {/* edit modal */}
      {ReactDOM.createPortal(
        <AddProductModal
          tags={tagOption}
          setTags={setTagOption}
          product={product}
          colors={colors}
          setColors={setColors}
          brands={brands}
        />,
        document.getElementById("addProduct")
      )}
    </div>
  );
}
